import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  day: 'Día 1',
  title: 'El Vaciado',
  description: 'Aplicas el Protocolo de 24 horas para vaciar toxinas y soltar retención de líquidos.'
}, {
  day: 'Días 2 al 6',
  title: 'La Reparación',
  description: 'Sigues la carga de nutrientes específicos para reparar tu metabolismo y recuperar energía.'
}, {
  day: 'Día 7',
  title: 'El Renacer',
  description: 'Evalúas tu nueva ligereza y estableces tu plan de mantenimiento sin restricciones.'
}];
export function HowItWorks() {
  return <section className="py-24 px-6 bg-brand-cream relative" data-id="element-70">
      <div className="max-w-4xl mx-auto" data-id="element-71">
        <motion.h2 className="text-3xl md:text-4xl font-bold text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-72">
          ¿Cómo funciona el reinicio?
        </motion.h2>

        <div className="relative" data-id="element-73">
          {/* Vertical line connecting steps */}
          <div className="absolute left-8 md:left-1/2 top-0 bottom-0 w-0.5 bg-brand-gold/30 transform md:-translate-x-1/2" data-id="element-74"></div>

          <div className="space-y-12" data-id="element-75">
            {steps.map((step, index) => <motion.div key={index} className={`relative flex flex-col md:flex-row items-start md:items-center gap-8 ${index % 2 === 0 ? 'md:flex-row-reverse' : ''}`} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.2
          }} data-id="element-76">
                {/* Number Circle */}
                <div className="absolute left-8 md:left-1/2 transform -translate-x-1/2 w-12 h-12 bg-brand-green rounded-full border-4 border-brand-cream flex items-center justify-center z-10 shadow-lg" data-id="element-77">
                  <span className="text-brand-gold font-bold text-lg" data-id="element-78">
                    {index + 1}
                  </span>
                </div>

                {/* Content Box */}
                <div className={`ml-20 md:ml-0 w-full md:w-1/2 ${index % 2 === 0 ? 'md:pl-12' : 'md:pr-12 text-left md:text-right'}`} data-id="element-79">
                  <div className="bg-white p-6 rounded-2xl shadow-sm border border-brand-rose/10 hover:shadow-md transition-shadow" data-id="element-80">
                    <span className="text-brand-rose font-bold text-sm uppercase tracking-wider mb-2 block" data-id="element-81">
                      {step.day}
                    </span>
                    <h3 className="text-xl font-bold text-brand-green mb-3" data-id="element-82">
                      {step.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed" data-id="element-83">
                      {step.description}
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}